





































































import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { questionsHeadersData } from '@/bundles/Questions/helpers';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { useStore } from '@/utils/use-store';
import { Exercise } from '@/helpers/types';
import { Nullable } from '@/bundles/App/type';
import { usePractice } from '@/composition-functions/usePractice';
import { RootState } from '@/store/types';
import { useQuestion } from '@/bundles/Questions/composables/useQuestion';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import QuestionsForm from '@/components/Questions/QuestionsForm.vue';
import { useExercises } from '@/views/Question/QuestionsList.vue';

export default defineComponent({
  components: {
    BaseTable,
    QuestionsForm,
  },

  emits: ['options:change', 'items:refresh'],

  props: {
    tableOptionsEntry: {
      type: Object,
      required: true,
    },
    itemsEntry: {
      type: Array,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
    categoriesEntry: {
      type: Array,
      default: () => [],
    },
  },

  setup: function (props, { emit }) {
    const store = useStore();

    const { exerciseTypes, user } = store.state as RootState;
    function getType(value: string): string {
      return exerciseTypes.find((item: { value: string; }) => item.value === value)?.name || '';
    }

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    function calculateHeight() {
      const total = window.innerHeight;
      const header = document.querySelector('.v-app-bar--fixed') as HTMLElement;
      const filters = document.querySelector('.filters-panel') as HTMLElement;
      const elementsHeight = header?.offsetHeight + filters?.offsetHeight + 64;
      // @ts-ignore
      return total - elementsHeight;
    }

    const {
      practiceList,
      fetchPractice,
    } = usePractice(user!.accessToken);
    const {
      createOrUpdateRequestPending: requestPending,
      update,
        create,
      archive,
    } = useQuestion();
    onMounted(function () {
      fetchPractice();
    });
    const { createExercise } = useExercises(user!.accessToken);
    const exerciseDrawer = ref(false);
    const mode = ref<'create'|'edit'>('create');
    const tempExercise = ref<Nullable<Exercise>>(null);

    function createQuestion() {
      exerciseDrawer.value = true
    }

    function toggleEdit(id: string) {
      mode.value = 'edit';
      const exercise = props.itemsEntry.find((exercise: any) => exercise.id === id)!;
      tempExercise.value = JSON.parse(JSON.stringify(exercise));
      exerciseDrawer.value = true;
    }

    function closeEventHandler() {
      exerciseDrawer.value = false;
      tempExercise.value = null;
    }

    async function updateRecord({ exercise, id }: { exercise: Exercise, id: string }) {
      await update(id, exercise);
      closeEventHandler();
      emit('items:refresh');
    }

    async function duplicate(payload: Exercise) {
      delete payload.id;
      await createExercise({ exercise: { ...payload, image: payload.image || '' } });
      closeEventHandler();
      emit('items:refresh');
    }

    async function archiveHandler(id: string) {
      await archive(id);
      closeEventHandler();
      emit('items:refresh');
    }

    async function createRecord({ exercise, id }: { exercise: Exercise, id: string }) {
      console.log(exercise);
      await create(id, exercise);
      closeEventHandler();
      emit('items:refresh');
    }

    return {
      questionsHeadersData,
      practiceList,
      exerciseDrawer,
      mode,
      tempExercise,
      requestPending,
      closeEventHandler,
      toggleEdit,
      updateRecord,
      createRecord,
      getType,
      optionsChangeEventHandler,
      createQuestion,
      calculateHeight,
      duplicate,
      archiveHandler,
    };
  },
});
